<template>
    <div class="app-modal-dialog--translation-exporter app-modal-dialog translation-exporter">
        <div class="app-modal-dialog__content">
            <div class="app-modal-dialog__header">
                <h3 class="app-modal-dialog__title">Export</h3>
                <app-button
                    v-if="!isOpen"
                    class="element-button--icon element-button"
                    @click="close()">
                    <svg class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
                </app-button>
            </div>
            <div class="app-modal-dialog__body grid">
                <div class="col-12 col-sm-6">
                    <h4 class="app-modal-dialog__section-title">Dictionary File (JSON)</h4>
                    <p class="app-modal-dialog__section-instructions">Download this translation's JSON dictionary file here.</p>
                    <div class="app-modal-dialog__section-buttons">
                        <a
                            class="element-button--secondary element-button"
                            :href="exportDictionaryUrl"
                            :disabled="status">
                            Download Dictionary
                        </a>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <h4 class="app-modal-dialog__section-title">
                        Assets (ZIP)
                        <span class="element-badge is--info">Generated on {{ locale?.assets_exported_at }}</span>
                    </h4>
                    <p class="app-modal-dialog__section-instructions">Generate all assets used in this translation and download them here.</p>
                    <div class="app-modal-dialog__section-buttons">
                        <a
                            class="element-button--secondary element-button"
                            :href="exportAssetsUrl"
                            :disabled="status">
                            Export Assets
                        </a>
                        <div v-if="hasDownloadableZip">
                            <a
                                class="element-button--secondary element-button"
                                :href="downloadAssetsUrl"
                                :disabled="status">
                                Download Assets
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import _ from 'lodash'

export default {
    components: {

    },
    props: {
        project: {
            type: Object,
            default: null
        },
        locale: {
            type: Object,
            default: null
        },
        exportAssetsUrl: {
            type: String,
            default: null
        },
        exportDictionaryUrl: {
            type: String,
            default: null
        },
    },
    data () {
        return {
            isOpen: false,
            status: null
        }
    },
    computed: {
        hasDownloadableZip () {
            return this.locale?.assets_export_zip && this.locale?.assets_exported_at
        },
        downloadAssetsUrl () {
            return this.exportAssetsUrl + "?download=1"
        },
    },
    methods: {
        close() {
            this.$emit('cancel', false)
        },
    },
    created () {

    },
    mounted () {

    }
}
</script>
